/**
 * @description: 检查用户是否具有某一个权限，如果是校验一个操作的权限，使用useCheckPermission(['菜单|组件code.操作code'])
 * @param {string} code 校验权限的code
 * @param {enum} type='FC' 校验权限的类型 FM：菜单权限 FC：组件权限
 * 使用方式：
 * useCheckPermission(['ALARM_PAGE'])
 * useCheckPermission(['ALARM_PAGE'], 'FM')
 */
import { useUserStore } from '@/store/user';
import { useTenantStore } from '@/store/tenant';
import { intersection } from '@/utils/index';

export const useCheckPermission = (authCodes: string[], type = 'FC'): boolean => {
  const userStore = useUserStore();
  const tenantStore = useTenantStore();
  const authKeys: string[] = userStore.authKeys;

  // 从租户 store 获取权限编码前缀
  const fmPermission = tenantStore.fmPermission;
  const fcPermission = tenantStore.fcPermission;

  if (type === 'FC') {
    return intersection(authKeys, authCodes.map((item) => `${fcPermission}${item}`)).length > 0;
  }

  return intersection(authKeys, authCodes.map((item) => `${fmPermission}${item}`)).length > 0;
};
